import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { App as CapApp } from '@capacitor/app';
import { isVersionLower } from '../utils/semver';

// Controllo aggiornamento app, SOLO su nativo. Confronta la versione installata
// (App.getInfo().version = MARKETING_VERSION/versionName) con la config del server
// (GET /config/app-version, guidata da env Render). Ricontrolla anche al resume.
// - updateRequired: installata < minSupportedVersion → blocco.
// - updateAvailable: installata < latestVersion → banner non bloccante.
// Best-effort: qualsiasi errore o config assente → non mostra nulla.

const STORE_URLS = {
    ios: 'https://apps.apple.com/app/id6761824063',
    android: 'https://play.google.com/store/apps/details?id=ch.ticinowild.mobile',
};

export const useAppUpdate = () => {
    const [state, setState] = useState({ updateAvailable: false, updateRequired: false, storeUrl: null });

    useEffect(() => {
        if (!Capacitor.isNativePlatform()) return undefined;
        let cancelled = false;
        let resumeListener;

        const check = async () => {
            try {
                const info = await CapApp.getInfo();
                const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/config/app-version`, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                });
                if (!response.ok || cancelled) return;
                const { payload } = await response.json();
                // Il payload è per-piattaforma (iOS e Android possono divergere per tempi di
                // review o hotfix single-platform): prendo il ramo della piattaforma corrente.
                const platform = Capacitor.getPlatform();
                const versions = payload?.[platform];
                if (!versions || cancelled) return;
                setState({
                    updateRequired: versions.minSupportedVersion ? isVersionLower(info.version, versions.minSupportedVersion) : false,
                    updateAvailable: versions.latestVersion ? isVersionLower(info.version, versions.latestVersion) : false,
                    storeUrl: STORE_URLS[platform] || null,
                });
            } catch (error) {
                console.error('Controllo aggiornamento app non riuscito:', error);
            }
        };

        check();
        (async () => {
            resumeListener = await CapApp.addListener('resume', check);
        })();

        return () => {
            cancelled = true;
            if (resumeListener) resumeListener.remove();
        };
    }, []);

    return state;
};
